module.exports = __webpack_public_path__ + "static/media/elixir-safety-img-1.d4328030.jpg";